import { buildUrl, usKidsGolfService } from '@/libs/api/instances/us-kids-golf-instance';

import type { GuardianNotificationsResponse } from '../notifications/types';

const notificationsUrl = buildUrl('/guardians/me/notifications');

export type GuardianNotificationsParams = {
  limit: number;
  cursor?: string;
  paginate: true;
};

export async function fetchGuardianNotifications(
  params: GuardianNotificationsParams,
): Promise<GuardianNotificationsResponse> {
  return await usKidsGolfService.get<GuardianNotificationsResponse>(notificationsUrl, params);
}

export async function markGuardianNotificationRead(id: string): Promise<void> {
  await usKidsGolfService.patch<void>(`${notificationsUrl}/${id}/read`);
}

export async function markAllGuardianNotificationsRead(): Promise<void> {
  await usKidsGolfService.patch<void>(`${notificationsUrl}/read-all`);
}

export async function deleteGuardianNotification(id: string): Promise<void> {
  await usKidsGolfService.delete<void>(`${notificationsUrl}/${id}`);
}
